import { useTranslation } from "react-i18next";
import InventoryBar from "../../components/inventory/InventoryBar";
import PageHeader from "../../components/shared/PageHeader"
import MainContent from "../../containers/shared/MainContent";
import PageMain from "../../containers/shared/PageMain"
import useDocumentTitle from "../../components/helpers/useDocumentTitle";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import apiClient from "../../components/utils/apiClient";
import { useEffect, useState } from "react";
import InventoryTable from "../../components/inventory/InventoryTable";
import Pagination from "../../components/shared/Pagination";
import Loading from "../../components/shared/Loading";

const InventoryHomePage = () => {


    const {t,i18n} = useTranslation();
    useDocumentTitle('المخزون');
    const navigate = useNavigate();
    const pageTitle = {title: 'المخزون', subTitle: 'يمكنك إضافة وادارة المخزون المسجل لديك.'};
    const [inventory,setInventory] = useState(null);
    

    const [pageSize, setPageSize] = useState(20);
    const [currentPage,setCurrentPage] = useState(1);
    const [total,setTotal] = useState(0);
    const [currentCount,setCurrentCount] = useState(0);
    const [hasMore,setHasMore] = useState(true);
    const [isEmpty, setIsEmpty] = useState(true);
    const [isLoading, setIsLoading] = useState(true);

    const [searchParams] = useSearchParams();
    const querySearch = searchParams.get('search') || "";

    useEffect(() => {
      if (querySearch.length > 0 && querySearch.length < 3) {
        return;
      }

      const delayDebounceFn = setTimeout(() => {
        getInventory(1, querySearch);
      }, 500);

      return () => clearTimeout(delayDebounceFn);
    }, [querySearch]);

    const getInventory = async (page=1, searchTerm = "") => {

      let url = `/b-inventory?skip=${(page-1)*pageSize}&limit=${pageSize}`;
      
      if (searchTerm && searchTerm.length >= 3) {
        url += `&itemName=${encodeURIComponent(searchTerm)}`;
      }
      try {
        const response = await apiClient.get(url);
        if(response?.data) {
          setIsLoading(false);
          setInventory(response?.data);
          if(response?.data?.length > 0) {
            setIsEmpty(false);
            setCurrentCount(response?.data?.length);
            setCurrentPage(page);
            if(response?.data?.length === pageSize) {
                setHasMore(true);
            }
          } else {
              setHasMore(false);
          }
        }
      } catch(err) {}
    }

    const handleChangePageAction = (page) => {
      getInventory(page);
    }



    useEffect(()=>{
      getInventory();
    },[]);



    return (
        <div>
            <PageHeader pageTitle={pageTitle} />
                  <PageMain>
                    <div className="fixed top-0 left-0 w-full h-full bg-grey-50 z-[-1]"></div>
                    <MainContent>
                        <InventoryBar inventoryCount={inventory?.length} />
                        {/* no inventory view */}
                        {inventory !== null && Array.isArray(inventory) && inventory?.length < 1 && !querySearch && !isEmpty && <Loading showLoading={true} />}
                        {inventory !== null && Array.isArray(inventory) && inventory?.length < 1 && !querySearch && isEmpty &&
                            <div className="pt-[80px] text-center">
                            <div className="inline-block w-[188px] h-[188px] !bg-contain !bg-center" style={{background: "url('/assets/images/archive.svg')"}}></div>
                            <div className="w-full text-center text-grey-900 text-[24px] font-[500] mb-[25px]">لم يتم إضافة أي مخزون حتى الآن</div>
                            <Link className="inline-block min-w-[320px] h-[48px] leading-[48px] rounded-[8px] text-white bg-grey-800 text-[18px] font-[600]" to="/ar/inventory/add">أضف مخزون جديد</Link>
                            </div>
                        }
                        {inventory !== null && Array.isArray(inventory) && inventory?.length < 1 && querySearch &&
                          <div className="pt-[80px] text-center">
                            <div className="inline-block w-[188px] h-[188px] !bg-contain !bg-center" style={{background: "url('/assets/images/archive.svg')"}}></div>
                            <div className="w-full text-center text-grey-900 text-[24px] font-[500] mb-[25px]">لايوجد مخزون مطابق لكلمة البحث</div>
                            {/* <Link className="inline-block min-w-[320px] h-[48px] leading-[48px] rounded-[8px] text-white bg-grey-800 text-[18px] font-[600]" to="/ar/users/add">أضف مستخدم جديد</Link> */}
                          </div>
                        }
                        {/* inventory view */}
                        {inventory !== null && Array.isArray(inventory) && inventory?.length > 0 && 
                            <div className="pt-[25px]">
                                <InventoryTable inventory={inventory} currentPage={currentPage} pageSize={pageSize} />
                                <Pagination label={'مخزون'} currentCount={currentCount} currentPage={currentPage} pageSize={pageSize} handleClickChangePage={page => handleChangePageAction(page)} hasMore={hasMore} />
                            </div>
                        }
                    </MainContent>
                  </PageMain>

                  {isLoading && <Loading showLoading={true} />}
        </div>
    )

}

export default InventoryHomePage;
